// Main application functionality
import Auth from './auth.js';
import BrowserUI from './browser.js';

// Create auth instance
const auth = new Auth();

// Create browser instance
let browser = null;

// Make auth available globally for debugging
window.auth = auth;

document.addEventListener('DOMContentLoaded', async function() {
    try {
        // Check if user is authenticated
        if (!(await auth.isAuthenticated())) {
            window.location.href = 'login.html';
            return;
        }

        // Update user menu with username
        const userMenu = document.getElementById('user-menu');
        const currentUser = await auth.getCurrentUser();
        if (userMenu && currentUser && currentUser.username) {
            userMenu.textContent = currentUser.username;
        }

        // Initialize S3 browser
        browser = new BrowserUI(auth);
        await browser.init();
        console.log('S3 Browser initialized successfully');

        // Setup event listeners after successful authentication
        setupEventListeners(userMenu, currentUser);

        // Hide loading screen and show main content
        document.getElementById('auth-loading').style.display = 'none';
        document.getElementById('main-content').style.display = 'block';

        console.log('MeltMedia initialized for user:', currentUser ? currentUser.username : 'unknown');

    } catch (error) {
        console.error('Failed to initialize application:', error);
        // On any error, redirect to login
        window.location.href = 'login.html';
    }
});

// Setup event listeners after authentication
function setupEventListeners(userMenu, currentUser) {
    // User menu (placeholder)
    if (userMenu) {
        userMenu.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('User menu clicked');
            // TODO: Implement user menu dropdown
        });
    }

    // Logout functionality
    const logoutBtn = document.getElementById('logout-btn');
    logoutBtn.addEventListener('click', async function(e) {
        e.preventDefault();

        try {
            await auth.signOut();
            window.location.href = 'login.html';
        } catch (error) {
            console.error('Logout failed:', error);
            // Force redirect even if logout fails
            window.location.href = 'login.html';
        }
    });
}